import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['campaigns']),

    /**
     * Whether the account has a provisioned RCS line. This — not an account-level feature flag — is
     * what makes RCS actually sendable: the send path resolves the `rcs:` sender off the line, so an
     * account without one has nothing to send from.
     *
     * Surfaces gated on this stay visible but disabled behind a CTA rather than disappearing.
     */
    hasRcsLine () {
      return Array.isArray(this.campaigns) &&
        this.campaigns.some(campaign => campaign.active && campaign.is_rcs_enabled)
    }
  }
}
